import Vue from 'vue'
import Toasted from 'vue-toasted'
import '@/assets/scss/vue-toasted.scss'
Vue.use(Toasted, {position: 'bottom-right', duration: 3000})